import { Component } from '@angular/core'

@Component({
  selector: 'app-open-treatment-icon',
  templateUrl: './open-treatment-icon.component.html',
  styleUrls: ['./open-treatment-icon.component.scss'],
  standalone: true,
  imports: []
})
export class OpenTreatmentIconComponent {
  constructor() {}
}
